// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1weC5","inputDescription":"styles_inputDescription__1tNWa"};